import React from "react";
import { Select, Form, Row, Col } from "antd";
//import { ArrowDownOutlined } from "@ant-design/icons";
//import { useFieldArray } from "react-hook-form";
import ControlledInput from "../../components/Backoffice/ControlledInput";
import ControlledSelect from "../../components/Backoffice/ControlledSelect";
import ControlledSwitch from "../../components/Backoffice/ControlledSwitch";
import FormSection from "../../components/Backoffice/FormSection";
const { Option } = Select;

/* const AddressForm = ({
  watch,
  name,
  errors,
  control,
  getCountryOptions,
  getCityOptions,
  getStateOptions,
  setValue,
  trigger,
}) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name,
  });

  const handleAdd = () => {
    append({
      addressLine1: "",
      addressLine2: "",
      district: "",
      city: "",
      state: "",
      country: "",
      pincode: "",
      landmark: "",
    });
  };

  const handleRemove = (index) => {
    remove(index);
  };

  const addressWatch = watch(name);
  const registeredAddress = watch("registeredAddress");
  const handleCopyRegisteredAddress = (index) => {
    const currentAddresses = [...addressWatch];
    currentAddresses[index] = { ...registeredAddress };
    setValue(name, currentAddresses, {
      shouldValidate: true,
      shouldDirty: true,
    });
    trigger(name);
  };

  return !addressWatch ? (
    ""
  ) : (
    <div>
      {fields.map((field, index) => (
        <div key={field.id}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: 10,
            }}
          >
            <span style={{ marginRight: 0, fontWeight: "bold" }}>
              {name === "billingAddress" ? "Billing Address" : "Pickup Address"}{" "}
              {index + 1}
            </span>

            {index > 0 ? (
              <Button onClick={() => handleRemove(index)} danger type="link">
                (Remove)
              </Button>
            ) : (
              ""
            )}
            <Button
              onClick={() => handleCopyRegisteredAddress(index)}
              type="link"
              icon={<ArrowDownOutlined />}
            >
              copy registered address
            </Button>
          </div>
          <Row gutter={24}>
            <Col span={12}>
              <ControlledInput
                required
                control={control}
                name={`${name}.${index}.addressLine1`}
                label="Address Line 1"
                errors={errors}
              />
            </Col>
            <Col span={12}>
              <ControlledInput
                control={control}
                name={`${name}.${index}.addressLine2`}
                label="Address Line 2"
                errors={errors}
              />
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={12}>
              <ControlledSelect
                required
                control={control}
                name={`${name}.${index}.country`}
                label="Country"
                options={getCountryOptions()}
                errors={errors}
                customChange={() => {
                  setValue(`${name}.${index}.state`, "");
                  setValue(`${name}.${index}.city`, "");
                }}
              />
            </Col>
            <Col span={12}>
              <ControlledSelect
                required
                control={control}
                name={`${name}.${index}.state`}
                label="State"
                options={getStateOptions(addressWatch[index]?.country)}
                customChange={() => {
                  setValue(`${name}.${index}.city`, "");
                }}
                errors={errors}
              />
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={12}>
              <ControlledSelect
                required
                control={control}
                name={`${name}.${index}.city`}
                label="City"
                options={getCityOptions(addressWatch[index]?.state)}
                errors={errors}
              />
            </Col>
            <Col span={12}>
              <ControlledInput
                required
                control={control}
                name={`${name}.${index}.pincode`}
                label="Pincode"
                errors={errors}
              />
            </Col>
          </Row>
        </div>
      ))}
      <Button onClick={handleAdd} type="dashed" block>
        Add Another{" "}
        {name === "billingAddress" ? "Billing Address" : "Pickup Address"}
      </Button>
    </div>
  );
}; */

const AddCompanyForm = ({
  options = {},
  control,
  watch,
  errors,
  setValue,
  trigger,
  isEdit = false,
}) => {
  const {
    businessType = [],
    paymentMethods = [],
    states = [],
    cities = [],
    countries = [],
  } = options;

  const getOptions = (entries) => {
    const opts = [];
    entries.forEach((entry) => {
      opts.push(
        <Option key={entry._id} value={entry._id}>
          {entry.label}
        </Option>
      );
    });

    return opts;
  };

  const getCountryOptions = () => {
    const opts = [];

    countries.forEach((country) => {
      opts.push(
        <Option key={country._id} value={country._id}>
          {country.name}
        </Option>
      );
    });
    return opts;
  };

  const getStateOptions = () => {
    const opts = [];
    /*   const filteredStates = states.filter(
      (state) => state.country === countryId
    );
    const sortedStates = getSortedList(filteredStates); */

    states.forEach((state) => {
      opts.push(
        <Option key={state._id} value={state._id}>
          {state.name}
        </Option>
      );
    });

    return opts;
  };

  const getCityOptions = () => {
    const opts = [];

    cities.forEach((city) => {
      opts.push(
        <Option key={city._id} value={city._id}>
          {city.name}
        </Option>
      );
    });
    return opts;
  };

  return (
    <Form colon={false}>
      <FormSection heading="Basic Information">
        <Row gutter={24}>
          <Col span={12}>
            <ControlledInput
              required
              control={control}
              name="companyName"
              label="Company Name"
              errors={errors}
            />
          </Col>
          <Col span={12}>
            <ControlledInput
              control={control}
              required
              name="gst"
              label="GST Number"
              errors={errors}
            />
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <ControlledSelect
              required
              control={control}
              name="businessType"
              label="Business Type"
              options={getOptions(businessType)}
              errors={errors}
            />
          </Col>
          <Col span={12}>
            <ControlledInput
              control={control}
              required
              name="pan"
              label="Business PAN"
              errors={errors}
            />
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <ControlledInput
              control={control}
              required
              name="cin"
              label="CIN Number"
              errors={errors}
            />
          </Col>
          <Col span={12}>
    <ControlledInput
      required
      control={control}
      name="abbreviation"
      label="Abbreviation (max 5 chars)"
      errors={errors}
      maxLength={5}
    />
  </Col>
        </Row>
      </FormSection>
      <FormSection heading="Registered Address">
        <Row gutter={24}>
          <Col span={12}>
            <ControlledInput
              required
              control={control}
              name="registeredAddress.addressLine1"
              label="Address Line 1"
              errors={errors}
            />
          </Col>
          <Col span={12}>
            <ControlledInput
              control={control}
              required={false}
              name="registeredAddress.addressLine2"
              label="Address Line 2"
              errors={errors}
            />
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <ControlledSelect
              required
              control={control}
              name="registeredAddress.country"
              label="Country"
              customChange={() => {
                setValue("registeredAddress.state", "");
                setValue("registeredAddress.city", "");
              }}
              options={getCountryOptions()}
              errors={errors}
            />
          </Col>
          <Col span={12}>
            <ControlledSelect
              required
              control={control}
              name="registeredAddress.state"
              customChange={() => {
                setValue("registeredAddress.city", "");
              }}
              label="State"
              options={getStateOptions()}
              errors={errors}
            />
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <ControlledSelect
              required
              control={control}
              name="registeredAddress.city"
              label="City"
              options={getCityOptions()}
              errors={errors}
            />
          </Col>
          <Col span={12}>
            <ControlledInput
              required
              control={control}
              name="registeredAddress.pincode"
              label="Pincode"
              errors={errors}
            />
          </Col>
        </Row>
      </FormSection>
      {/*<FormSection heading="Billing Address">
        <AddressForm
          control={control}
          errors={errors}
          name="billingAddress"
          watch={watch}
          getCountryOptions={getCountryOptions}
          getStateOptions={getStateOptions}
          getCityOptions={getCityOptions}
          trigger={trigger}
          setValue={setValue}
        />
      </FormSection>
      <FormSection heading="Pickup Address">
        <AddressForm
          control={control}
          errors={errors}
          name="pickupAddress"
          watch={watch}
          getCountryOptions={getCountryOptions}
          getStateOptions={getStateOptions}
          getCityOptions={getCityOptions}
          trigger={trigger}
          setValue={setValue}
            />
            </FormSection>*/}
      <FormSection heading="User Permissions">
        <Row gutter={24}>
          <Col span={24}>
            <ControlledSwitch
              required
              control={control}
              name="priceVisible"
              label="Allow users to view prices"
              errors={errors}
            />
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={24}>
            <ControlledSwitch
              required
              control={control}
              name="allowUserPickupAddress"
              label="Allow users to Add New Pickup Address"
              errors={errors}
            />
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <ControlledSelect
              multiple
              required
              control={control}
              name="paymentMethodsAvailable"
              label="Payment Method"
              options={getOptions(paymentMethods)}
              errors={errors}
            />
          </Col>
        </Row>
      </FormSection>
      {!isEdit && (
        <FormSection heading="Company Administrator">
          <Row gutter={24}>
            <Col span={12}>
              <ControlledInput
                required
                control={control}
                name="admin.firstName"
                label="First Name"
                errors={errors}
              />
            </Col>
            <Col span={12}>
              <ControlledInput
                required
                control={control}
                name="admin.lastName"
                label="Last Name"
                errors={errors}
              />
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={12}>
              <ControlledInput
                required
                control={control}
                name="admin.email"
                label="Email"
                errors={errors}
              />
            </Col>
            <Col span={12}>
              <ControlledInput
                required
                control={control}
                name="admin.phone"
                label="Phone (10 digits)"
                errors={errors}
                maxLength={10}
              />
            </Col>
          </Row>
        </FormSection>
      )}
    </Form>
  );
};

export default AddCompanyForm;
